import React from 'react';

import { BaseIconProps } from '../interfaces';

const FreshTagIcon: React.FC<BaseIconProps> = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    zoomAndPan="magnify"
    viewBox="0 0 375 374.999991"
    height={height}
    preserveAspectRatio="xMidYMid meet"
    version="1.0"
  >
    <rect
      x="-37.5"
      width="450"
      fill="#ffffff"
      y="-37.499999"
      height="449.999989"
      fillOpacity="1"
    />
    <rect
      x="-37.5"
      width="450"
      fill="#ffffff"
      y="-37.499999"
      height="449.999989"
      fillOpacity="1"
    />
    <path
      fill={color}
      d="M 261.734375 125 C 121.109375 156.25 88.296875 252.65625 55.796875 333.4375 L 85.328125 343.75 L 100.171875 307.8125 C 107.671875 310.46875 115.484375 312.5 121.109375 312.5 C 292.984375 312.5 339.859375 46.875 339.859375 46.875 C 324.234375 78.125 214.859375 82.03125 136.734375 97.65625 C 58.609375 113.28125 27.359375 179.6875 27.359375 210.9375 C 27.359375 242.1875 54.703125 269.53125 54.703125 269.53125 C 105.484375 125 261.734375 125 261.734375 125 Z M 261.734375 125 "
      fillOpacity="1"
      fillRule="nonzero"
    />
  </svg>
);

export default FreshTagIcon;
